import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';


type State = {
  homePage: any;
  promotionBanner: any;
  popupBanner: any;

  body: any;
  language: {
    label: string;
    value: string;
    origin: string;
  }
}

const initialState: State = {
  homePage: {},
  promotionBanner: null,
  popupBanner: null,
  body: [],
  language: {
    label: 'en-us',
    value: 'zh',
    origin: 'en'
  }
};

const NAME = 'homePage';
export const homePageSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    changeHomePage: (state, action) => {
      state.homePage = action.payload || {};
    },
    changeBody: (state, action) => {
      state.body = action.payload;
    },
    changePromotionBanner: (state, action) => {
      state.promotionBanner = action.payload || null;
    },
    changePopupBanner: (state, action) => {
      state.popupBanner = action.payload || null;
    },
    changeLanguage: (state, action) => {
      state.language = action.payload
    },

    getHomePageSuccess: (state, action) => {
      state.body = action.payload || [];
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => ({
      ...state,
      ...action.payload[NAME]
    }))
  },
});

export const {
  changeHomePage,
  getHomePageSuccess,
  changePromotionBanner,
  changePopupBanner,
  changeBody,
  changeLanguage
} = homePageSlice.actions;
export default homePageSlice;
